import DOMPurify from "/web_modules/dompurify.js";
var counter = 0;
var id = "";
var addToSet = function(set, array) {
  var l = array.length;
  while (l--) {
    set[array[l]] = true;
  }
  return set;
};
var ALLOWED_CSS_PROPERTY = addToSet({}, ["background", "background-", "border", "border-", "outline", "outline-", "margin", "margin-", "padding", "padding-", "list-style", "list-style-type", "list-style-image", "list-style-position", "font", "font-", "color", "opacity", "direction", "letter-spacing", "line-break", "line-height", "overflow-wrap", "text-", "vertical-align", "white-space", "word-spacing", "word-wrap", "word-break", "display", "position", "visibility", "overflow", "overflow-x", "overflow-y", "z-index", "zoom", "top", "right", "bottom", "left", "width", "height", "min-width", "min-height", "max-width", "max-height", "float", "clear", "clip", "clip-path", "object-fit", "object-position", "border-collapse", "border-spacing", "caption-side", "empty-cells", "table-layout", "content", "quotes", "orphans", "page-break-after", "page-break-before", "page-break-inside", "widows", "box-shadow", "text-shadow", "animation", "animation-", "transform", "transform-origin", "transform-style", "perspective", "perspective-origin", "transition", "transition-", "align-", "flex", "flex-", "justify-content", "order", "columns", "column-"]);
var sanitiseSelector = function(selector) {
  return selector.split(",").map(function(selector2) {
    if (/^(?:html|body)(?!\w)/.test(selector2)) {
      selector2 = selector2.slice(4);
    }
    return "#" + id + " " + selector2.replace(/([#.]|\[\s*(?:id|class|for)\s*[~|^]?=\s*["'])/gi, "$1" + id + "-");
  }).join(",");
};
var sanitiseStyle = function(style) {
  var output = "";
  var i, l, name, value, important, nonPrefixName;
  for (i = 0, l = style.length; i < l; i += 1) {
    name = style[i];
    if (/-value$/.test(name)) {
      name = name.slice(0, -6);
    }
    if (/background-repeat-/.test(name)) {
      name = "background-repeat";
    }
    value = style.getPropertyValue(name);
    important = style.getPropertyPriority(name);
    nonPrefixName = name.charAt(0) === "-" ? name.slice(name.indexOf("-", 1) + 1) : name;
    if (value && (ALLOWED_CSS_PROPERTY[nonPrefixName] || ALLOWED_CSS_PROPERTY[nonPrefixName.slice(0, nonPrefixName.indexOf("-") + 1)])) {
      if (name === "position") {
        if (value === "fixed") {
          value = "absolute";
        }
        if (!/^(?:absolute|relative|static)$/.test(value)) {
          continue;
        }
      }
      output += name;
      output += ":";
      output += value;
      if (important) {
        output += " !" + important;
      }
      output += ";";
    }
  }
  return output;
};
var STYLE_RULE = 1;
var MEDIA_RULE = 4;
var KEYFRAMES_RULE = 7;
var KEYFRAME_RULE = 8;
var sanitiseStylesheet = function(sheet, output) {
  var rules = sheet.cssRules;
  var i, l, rule, recurse, selectorText;
  if (!rules) {
    return output;
  }
  for (i = 0, l = rules.length; i < l; i += 1) {
    rule = rules[i];
    recurse = false;
    switch (rule.type) {
      case STYLE_RULE:
        selectorText = rule.selectorText || "";
        output.push(sanitiseSelector(selectorText));
        output.push("{");
        output.push(sanitiseStyle(rule.style));
        output.push("}\n");
        break;
      case MEDIA_RULE:
        output.push("@media ");
        output.push(rule.media.mediaText);
        recurse = true;
        break;
      case KEYFRAMES_RULE:
        output.push("@keyframes ");
        output.push(id + "-" + rule.name);
        recurse = true;
        break;
      case KEYFRAME_RULE:
        output.push(rule.keyText);
        output.push("{");
        output.push(sanitiseStyle(rule.style));
        output.push("}\n");
        break;
    }
    if (recurse) {
      output.push("{\n");
      sanitiseStylesheet(rule, output);
      output.push("}\n");
    }
  }
  return output;
};
var uponSanitizeElement = function(node, data) {
  if (data.tagName === "style") {
    node.textContent = sanitiseStylesheet(node.sheet, []).join("");
  }
};
var uponSanitizeAttribute = function(node, data) {
  var name = data.attrName;
  var value = data.attrValue;
  if (name === "style") {
    data.attrValue = sanitiseStyle(node.style);
  }
  if (name === "id" || name === "for") {
    data.attrValue = id + "-" + value;
  }
  if (name === "class") {
    data.attrValue = value.trim().split(/\s+/).map(function(className) {
      return id + "-" + className;
    }).join(" ");
  }
};
var afterSanitizeAttributes = function(node) {
  if (node.nodeName === "A") {
    node.rel = "noreferrer";
    node.target = "_blank";
  }
};
DOMPurify.addHook("uponSanitizeElement", uponSanitizeElement);
DOMPurify.addHook("uponSanitizeAttribute", uponSanitizeAttribute);
DOMPurify.addHook("afterSanitizeAttributes", afterSanitizeAttributes);
var FORBID_TAGS = "audio blink decorator element marquee template video".split(" ");
var FORBID_ATTR = "action method tabindex xmlns".split(" ");
export var drawHTML = function(html) {
  counter += 1;
  id = "defanged" + counter;
  var documentElement = DOMPurify.sanitize(html, {
    FORBID_TAGS,
    FORBID_ATTR,
    ALLOW_DATA_ATTR: false,
    WHOLE_DOCUMENT: true,
    RETURN_DOM: true,
    SANITIZE_DOM: true
  });
  var elements, i, l;
  var output = document.createElement("div");
  output.id = id;
  output.style.cssText = "z-index:0";
  documentElement = document.adoptNode(documentElement);
  elements = Array.prototype.slice.call(documentElement.getElementsByTagName("style"));
  for (i = 0, l = elements.length; i < l; i += 1) {
    output.appendChild(elements[i]);
  }
  elements = Array.prototype.slice.call(documentElement.lastElementChild.childNodes);
  for (i = 0, l = elements.length; i < l; i += 1) {
    output.appendChild(elements[i]);
  }
  return output;
};
